import React from 'react';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';

ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    Title
);

const createRadialGradient = (ctx, area, color) => {
    const gradient = ctx.createRadialGradient(
        area.width / 2,
        area.height / 2,
        40,
        area.width / 2,
        area.height / 2,
        area.width
    );
    gradient.addColorStop(0, color);
    gradient.addColorStop(1, color + '88');
    return gradient;
};

export default class PieChartTemplate2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: window.innerWidth < 768,
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        this.setState({ isMobile: window.innerWidth < 768 });
    };

    render() {
        const {
            graphData,
            colors,
            yLabel,
            layoutItem
        } = this.props;

        const reportConfig =
            layoutItem &&
            layoutItem.itemProperties &&
            layoutItem.itemProperties.reportConfig;

        const externalUrl = reportConfig && reportConfig.externalUrl;
        const targetProperty = reportConfig && reportConfig.targetProperty;

        const { isMobile } = this.state;

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            cutout: isMobile ? '60%' : '55%',

            onClick: (event, elements) => {
                if (!elements.length) return;
                if (externalUrl && targetProperty) {
                    const index = elements[0].index;
                    const clickedStockData = graphData[index];

                    let str = targetProperty.replace('{{', '').replace('}}', '');
                    const prefix = '__ADDITIONAL_MODEL_DATA.';
                    if (str.startsWith(prefix)) {
                        str = str.replace(/^__ADDITIONAL_MODEL_DATA\.[^.]+\./, '');
                    }

                    const baseUrl = window.location.origin;
                    if (clickedStockData && clickedStockData.xProperties) {
                        const redirectUrl =
                            baseUrl +
                            '/app/' +
                            externalUrl +
                            '?ct=' +
                            str +
                            ':' +
                            clickedStockData.xProperties;

                        window.location.href = redirectUrl;
                    }
                }
            },

            plugins: {
                legend: {
                    position: 'bottom',
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'circle',
                        padding: 14,
                        font: {
                            size: 12,
                            weight: '500',
                        },
                    },
                },
                tooltip: {
                    backgroundColor: '#111827',
                    titleColor: '#ffffff',
                    bodyColor: '#e5e7eb',
                    cornerRadius: 10,
                    padding: 14,
                },
                title: {
                    display: true,
                    text: yLabel,
                    font: {
                        size: isMobile ? 15 : 18,
                        weight: 'bold',
                    },
                    padding: {
                        bottom: isMobile ? 16 : 24,
                    },
                },
            },
            animation: {
                animateRotate: true,
                duration: 1400,
                easing: 'easeOutQuart',
            },
        };

        let labels = [];
        let values = [];

        if (graphData && graphData.length) {
            graphData.forEach(item => {
                labels.push(item.xProperties);
                values.push(item.yProperties);
            });
        }

        const chartData = {
            labels,
            datasets: [
                {
                    label: yLabel,
                    data: values,
                    borderWidth: 2,
                    borderColor: '#ffffff',
                    hoverOffset: isMobile ? 8 : 12,
                    backgroundColor: (context) => {
                        const { chart } = context;
                        const { ctx, chartArea } = chart;
                        if (!chartArea) return colors;
                        return colors.map(color =>
                            createRadialGradient(ctx, chartArea, color)
                        );
                    },
                },
            ],
        };

        return (
            <div
                style={{
                    height: isMobile ? '360px' : '420px',
                    width: '100%',
                    padding: isMobile ? '14px' : '20px',
                    background: '#ffffff',
                    borderRadius: '18px',
                }}
            >
                <Pie options={options} data={chartData} />
            </div>
        );
    }
}
